import Auth from 'Components/Layouts/Auth';
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {CountryDropdown} from 'react-country-region-selector';
import PhoneInput from 'react-phone-input-2';
import {Redirect, withRouter} from 'react-router-dom';

import { FormHandler, Input, Label, Checkbox, FileUpload } from 'Components/Form';
import {Alert} from 'Components/Partials';
import Main from 'Components/Layouts/Authenticated';

import {User} from 'Services';
import Me from 'Services/Api/Me/Me';
import {RedButton} from 'Components/Button';
import { asset } from 'Services/BaseHelpers';
import Dietaries from "Components/Form/Dietaries";
import { getFallbackAvatarUrl } from "Services/AuthHelpers";

class Profile extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var inputRef
     * @type {HTMLInputElement}
     */
    inputRef;

    state = {
        file: null,
    };

    channels = [
        {value: 'Boots', label: 'Boots'},
        {value: 'Customer Center', label: 'Customer Center'},
        {value: 'Fenwick', label: 'Fenwick'},
        {value: 'Flagship', label: 'Flagship'},
        {value: 'John Lewis Partnership', label: 'John Lewis Partnership'},
        {value: 'Support Office', label: 'Support Office'},
        {value: 'Agency Partner', label: 'Agency Partner'},
        {value: 'Signature Team', label: 'Signature Team'},
    ];

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.props.setForm({
            ...User.data
        });
    };
    header = () => (
        <div className="h-banner bg-banner-profile bg-no-repeat bg-cover bg-right relative">
            <div className="absolute h-full w-full flex">
                <span className="m-auto text-app-green-banner text-4xl font-gilroy">My Profile</span>
            </div>
            <img
                alt=""
                src={ asset ( '/images/pages/profile/left.svg' ) }
                className="max-h-banner hidden md:block h-full px-2 md:px-4 lg:px-6  py-5 lg:mt-0"
            />
        </div>
    );

    /**
     * @method handleOpenInput
     */
    handleOpenInput = () => {
        this.inputRef.click();
    };

    /**
     * @method handleFileChange
     * @param {FileList} e
     */
    handleFileChange = async (e) => {
        const f = e.length > 0 ? e[0] : null;

        await this.props.handleInput('file', f);
        await this.handleFile(f);
        this.props.handleSubmit(null, Me.updateAvatar, 'Your avatar has been updated successfully');
    };

    /**
     * @method handleFile
     * @param {File} file
     */
    handleFile = (file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            this.setState({
                file: e.target.result,
            });
        };

        reader.readAsDataURL(file);
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {form, working, alert, handleInput, handleSubmit, remoteControlSession = null} = this.props;

        if (alert && alert.message === this.success) {
            return (
                <Redirect to="/map"/>
            )
        }

        if(remoteControlSession){
            return (
                <>
                    <div className="grid grid-cols-5 md:grid-cols-1 text-center flex flex-col">
                        <div className="col-span-5 flex justify-end">
                            {this.renderAvatar()}
                        </div>
                    </div>

                    {this.renderProfileForm()}
                </>
            );
        }

        return (
            <Auth customHeader={this.header()} header="auth" contentClass = 'w-full flex-1 h-full bg-app-gray -mt-1'>
                <div className="grid md:grid-cols-5 text-center flex flex-col ">
                    <div className="col-span-5 flex justify-end">
                        {this.renderAvatar()}
                    </div>
                </div>
                {this.renderProfileForm()}
            </Auth>
        );
    }
    /**
     * @method renderAvatar
     * @return {JSX.Element}
     */
    renderProfileForm = () => {
        const {form, working, alert, handleInput, handleSubmit, remoteControlSession = null} = this.props;

        return (
            <div className="grid md:grid-cols-4 mt-8 font-gilroy">
                <div className="col-span-4">
                        <form className="w-full mt-4" onSubmit={(e) => handleSubmit(e, Me.update, this.success)}>
                            {alert !== null && (<Alert {...alert} />)}

                            <div className="grid md:grid-cols-2 gap-2 mb-4">
                                <div>
                                    <Input
                                        label="First Name"
                                        value={form.first_name}
                                        onChange={(v) => handleInput('first_name', v)}
                                        app={true}
                                    />
                                </div>

                                <div>
                                    <Input
                                        label="Last Name"
                                        value={form.last_name}
                                        onChange={(v) => handleInput('last_name', v)}
                                        app={true}
                                    />
                                </div>
                            </div>

                            <div className="grid md:grid-cols-2 gap-2 mb-4">

                                <div className="mb-4">
                                    <Input
                                        label="Email Address"
                                        value={form.email}
                                        type="email"
                                        onChange={(v) => handleInput('email', v)}
                                        app={true}
                                    />
                                </div>

                                <div className="mb-4">
                                    <Label label="Country" app={true}/>
                                    <CountryDropdown
                                        value={form.country ?? ''}
                                        onChange={(val) => handleInput('country', val)}
                                        classes="w-full border-none rounded-full font-gilroy py-3"
                                    />
                                </div>
                            </div>
                            {/*<div className="grid md:grid-cols-2 gap-2 mb-4">
                                <div>
                                    <Label label="Contact Number" app={true}/>

                                    <div className="country-code-dropdown">
                                        <PhoneInput
                                            containerClass="rounded-full px-4 bg-white py-1 font-gilroy"
                                            buttonClass="border-none"
                                            country="gb"
                                            value={form.contact_number ?? ''}
                                            onChange={phone => handleInput('contact_number', phone)}
                                            enableAreaCodes={true}
                                        />
                                    </div>
                                </div>
                            </div>*/}

                            {/* <div className="flex items-center mb-4">
                                <Label label="Are you a Pentland Employee?" app={true} className="mr-16 mb-0"/>

                                <Checkbox
                                    label="Yes"
                                    labelPlacement="right"
                                    app={true}
                                    value={form.pentland_employee}
                                    onChange={() => handleInput('pentland_employee', true)}
                                    containerClassName="mr-4"
                                />
                                <Checkbox
                                    label="No"
                                    labelPlacement="right"
                                    app={true}
                                    value={form.pentland_employee === false}
                                    onChange={() => handleInput('pentland_employee', false)}
                                />
                            </div>*/}
                            <React.Fragment>
                                <div className="grid md:grid-cols-2 gap-4 mb-4">
                                    {/*<div className="mb-4">*/}
                                    {/*    <Dietaries*/}
                                    {/*        label="Do you have any dietary requirements?"*/}
                                    {/*        value={form?.dietaries}*/}
                                    {/*        onChange={(v) => handleInput('dietaries', v)}*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                    <div className="mb-4">
                                        <Input
                                            label="Special access requirements "
                                            app={true}
                                            value={form.special_requirements}
                                            onChange={(v) => handleInput('special_requirements', v)}
                                        />
                                    </div>
                                </div>

                                {/*<p className={"mb-8"}>*/}
                                {/*    Emergency contact details*/}
                                {/*</p>*/}
                                {/*<div className="grid md:grid-cols-2 gap-8 mb-8">*/}
                                {/*    <div>*/}
                                {/*        <Input*/}
                                {/*            label="Name"*/}
                                {/*            value={form.emergency_contact_name}*/}
                                {/*            onChange={(v) => handleInput('emergency_contact_name', v)}*/}
                                {/*            app={true}*/}
                                {/*        />*/}
                                {/*    </div>*/}

                                {/*    <div>*/}
                                {/*        <Input*/}
                                {/*            label="Relationship to you"*/}
                                {/*            value={form.emergency_contact_relationship}*/}
                                {/*            onChange={(v) => handleInput('emergency_contact_relationship', v)}*/}
                                {/*            app={true}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className="mb-8">*/}
                                {/*        <Label label="Emergency Contact Number" app={true} />*/}
                                {/*        <div className="country-code-dropdown">*/}
                                {/*            <PhoneInput*/}
                                {/*                containerClass="rounded-full px-4 bg-white py-1 font-gilroy"*/}
                                {/*                buttonClass="border-none"*/}
                                {/*                country="gb"*/}
                                {/*                value={form.emergency_contact_number ?? ''}*/}
                                {/*                onChange={phone => handleInput('emergency_contact_number', phone)}*/}
                                {/*                enableAreaCodes={true}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </React.Fragment>
                            {/*<div className="flex items-center mb-8">*/}
                            {/*    <Label*/}
                            {/*        label="Filming will be taking place during the live launch, please tick here if you would like to opt out"*/}
                            {/*        app={true}*/}
                            {/*        className="mr-16 mb-0"*/}
                            {/*    />*/}

                            {/*    <Checkbox*/}
                            {/*        app={true}*/}
                            {/*        value={form.filming_opt_out}*/}
                            {/*        onChange={() => handleInput('filming_opt_out', !form.filming_opt_out)}*/}
                            {/*        containerClassName="mr-4"*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div className="flex items-center mb-4">
                                <Label label="Do you wish to opt out of networking?"
                                       app={true} className="mr-16 mb-0"/>

                                <Checkbox
                                    label="Yes"
                                    labelPlacement="right"
                                    app={true}
                                    value={form.ignore_on_networking}
                                    onChange={() => handleInput('ignore_on_networking', true)}
                                    containerClassName="mr-4"
                                />

                                <Checkbox
                                    label="No"
                                    labelPlacement="right"
                                    app={true}
                                    value={!form.ignore_on_networking}
                                    onChange={() => handleInput('ignore_on_networking', false)}
                                />
                            </div>

                            <div className="mt-8 text-center">
                                <RedButton
                                    text="Save"
                                    working={working}
                                />
                            </div>
                        </form>
                    </div>
                {/*<div className="hidden md:block">
                        {this.renderAvatar()}
                    </div>*/}
            </div>
        );
    }

    /**
     * @method renderAvatar
     * @return {JSX.Element}
     */
    renderAvatar = () => {
        const {file } = this.state;
        const {form, working, alert, handleInput, handleSubmit} = this.props;

        return (
            <div className="text-center mx-auto cursor-pointer">
                 <FileUpload
                     containerClassName="mx-auto mb-8"
                     value={form.avatar_path}
                     onChange={v => handleInput('avatar_path', v)}
                     accept="image/*"
                     placeholder="Update Avatar"
                     fallbackImage={getFallbackAvatarUrl(form)}
                 />

{/*                <img alt="" src={file ? file : User.getAvatarUrl()}
                     className="mx-auto mb-4 h-28 w-28 md:h-44 md:w-44 rounded-full bg-app-secondary-blue object-cover border border-black"/>

                <button
                    onClick={this.handleOpenInput}
                    className="font-proxima-nova text-black cursor-pointer transition duration-200 hover:text-app-gray"
                >
                    <FontAwesomeIcon icon={faPencilAlt} className="mr-1"/> edit
                </button>*/}
            </div>
        );
    };
}

export default FormHandler(withRouter(Profile));
